/* eslint-disable */
/* DONT MODIFY THIS FILE DIRECTLY. SEE README.md */


/* parser generated by jison 0.4.18 */
/*
  Returns a Parser object of the following structure:

  Parser: {
    yy: {}
  }

  Parser.prototype: {
    yy: {},
    trace: function(),
    symbols_: {associative list: name ==> number},
    terminals_: {associative list: number ==> name},
    productions_: [...],
    performAction: function anonymous(yytext, yyleng, yylineno, yy, yystate, $$, _$),
    table: [...],
    defaultActions: {...},
    parseError: function(str, hash),
    parse: function(input),

    lexer: {
        EOF: 1,
        parseError: function(str, hash),
        setInput: function(input),
        input: function(),
        unput: function(str),
        more: function(),
        less: function(n),
        pastInput: function(),
        upcomingInput: function(),
        showPosition: function(),
        test_match: function(regex_match_array, rule_index),
        next: function(),
        lex: function(),
        begin: function(condition),
        popState: function(),
        _currentRules: function(),
        topState: function(),
        pushState: function(condition),

        options: {
            ranges: boolean           (optional: true ==> token location info will include a .range[] member)
            flex: boolean             (optional: true ==> flex-like lexing behaviour where the rules are tested exhaustively to find the longest match)
            backtrack_lexer: boolean  (optional: true ==> lexer regexes are tested in order and for each matching regex the action code is invoked; the lexer terminates the scan when a token is returned by the action code)
        },

        performAction: function(yy, yy_, $avoiding_name_collisions, YY_START),
        rules: [...],
        conditions: {associative list: name ==> set},
    }
  }


  token location info (@$, _$, etc.): {
    first_line: n,
    last_line: n,
    first_column: n,
    last_column: n,
    range: [start_number, end_number]       (where the numbers are indexes into the input string, regular zero-based)
  }


  the parseError function receives a 'hash' object with these members for lexer and parser errors: {
    text:        (matched text)
    token:       (the produced terminal token, if any)
    line:        (yylineno)
  }
  while parser (grammar) errors will also provide these members, i.e. parser errors deliver a superset of attributes: {
    loc:         (yylloc)
    expected:    (string describing the set of expected tokens)
    recoverable: (boolean: TRUE when the parser has a error recovery rule available for this particular error)
  }
*/
var parser = (function(){
var o=function(k,v,o,l){for(o=o||{},l=k.length;l--;o[k[l]]=v);return o},$V0=[1,4],$V1=[1,13],$V2=[1,5],$V3=[1,6],$V4=[1,7],$V5=[1,8],$V6=[1,9],$V7=[1,10],$V8=[1,16],$V9=[1,11],$Va=[1,12],$Vb=[1,14],$Vc=[1,15],$Vd=[1,17],$Ve=[1,18],$Vf=[1,19],$Vg=[1,20],$Vh=[1,21],$Vi=[1,22],$Vj=[1,23],$Vk=[1,24],$Vl=[1,25],$Vm=[1,26],$Vn=[1,28],$Vo=[1,29],$Vp=[1,30],$Vq=[1,31],$Vr=[1,32],$Vs=[1,33],$Vt=[1,34],$Vu=[1,35],$Vv=[1,36],$Vw=[1,37],$Vx=[1,38],$Vy=[1,39],$Vz=[1,40],$VA=[1,41],$VB=[5,8,9,18,19,20,21,22,23,24,25,26,27,28,29,30,31],$VC=[5,8,9,18,19,20,21],$VD=[5,8,9,18,19,20,21,22,23,24,25],$VE=[5,8,9,18,19,20,21,22,23,24,25,26,27],$VF=[5,8,9,18,19,20,21,22,23,24,25,26,27,28,29,30];
var parser = {trace: function trace () { },
yy: {},
symbols_: {"error":2,"expressions":3,"e":4,"EOF":5,"FLOOR":6,"(":7,")":8,",":9,"CEIL":10,"ROUND":11,"ABS":12,"TO_UTC":13,"IIF":14,"SUM_INST":15,"QID":16,"REVSCORE":17,"OR":18,"AND":19,"EQ":20,"NEQ":21,"GTE":22,"GT":23,"LTE":24,"LT":25,"+":26,"-":27,"*":28,"/":29,"%":30,"^":31,"NUMBER":32,"DATE":33,"COUNTER":34,"LITERAL":35,"E":36,"PI":37,"GENDER":38,"AGE":39,"SUBJECTTYPEID":40,"M":41,"F":42,"NULL":43,"$accept":0,"$end":1},
terminals_: {2:"error",5:"EOF",6:"FLOOR",7:"(",8:")",9:",",10:"CEIL",11:"ROUND",12:"ABS",13:"TO_UTC",14:"IIF",15:"SUM_INST",16:"QID",17:"REVSCORE",18:"OR",19:"AND",20:"EQ",21:"NEQ",22:"GTE",23:"GT",24:"LTE",25:"LT",26:"+",27:"-",28:"*",29:"/",30:"%",31:"^",32:"NUMBER",33:"DATE",34:"COUNTER",35:"LITERAL",36:"E",37:"PI",38:"GENDER",39:"AGE",40:"SUBJECTTYPEID",41:"M",42:"F",43:"NULL"},
productions_: [0,[3,2],[3,1],[4,4],[4,6],[4,4],[4,6],[4,4],[4,6],[4,4],[4,4],[4,8],[4,4],[4,4],[4,3],[4,3],[4,3],[4,3],[4,3],[4,3],[4,3],[4,3],[4,3],[4,3],[4,3],[4,3],[4,3],[4,3],[4,2],[4,3],[4,1],[4,1],[4,1],[4,1],[4,1],[4,1],[4,1],[4,1],[4,1],[4,1],[4,1],[4,1],[4,1]],
performAction: function anonymous(yytext, yyleng, yylineno, yy, yystate /* action[1] */, $$ /* vstack */, _$ /* lstack */) {
/* this == yyval */

var $0 = $$.length - 1;
switch (yystate) {
case 1:
return $$[$0-1];
break;
case 2:
 return "No input was provided."; 
break;
case 3:
this.$ = Math.floor($$[$0-1]); 
break;
case 4:
this.$ = Math.floor($$[$0-3]/$$[$0-1]) * $$[$0-1]; 
break;
case 5:
this.$ = Math.ceil($$[$0-1]); 
break;
case 6:
this.$ = Math.ceil($$[$0-3]/$$[$0-1]) * $$[$0-1]; 
break;
case 7:
this.$ = Math.round($$[$0-1]); 
break;
case 8:
this.$ = Math.round($$[$0-3]*Math.pow(10,$$[$0-1])) / Math.pow(10,$$[$0-1]); 
break;
case 9:
this.$ = Math.abs($$[$0-1]); 
break;
case 10:
this.$ = Date.parse($$[$0-1]); 
break;
case 11:
this.$ = $$[$0-5] ? $$[$0-3] : $$[$0-1]; 
break;
case 12:
this.$ = yy.sumOverAllInstances($$[$0-1].substring(1,$$[$0-1].length-1)); 
break;
case 13:
this.$ = yy.reverseScore($$[$0-1].substring(1,$$[$0-1].length-1)); 
break;
case 14:
this.$ = ($$[$0-2] || $$[$0]);
break;
case 15:
this.$ = ($$[$0-2] && $$[$0]);
break;
case 16:
this.$ = $$[$0-2] == $$[$0];
break;
case 17:
this.$ = $$[$0-2]!= $$[$0];
break;
case 18:
this.$ = +($$[$0-2]) >= +($$[$0]);
break;
case 19:
this.$ = +($$[$0-2]) > +($$[$0]);
break;
case 20:
this.$ = +($$[$0-2]) <= +($$[$0]);
break;
case 21:
this.$ = +($$[$0-2]) < +($$[$0]);
break;
case 22:
this.$ = +($$[$0-2]) + +($$[$0]);
break;
case 23:
this.$ = +($$[$0-2]) - +($$[$0]);
break;
case 24:
this.$ = +($$[$0-2]) * +($$[$0]);
break;
case 25:
this.$ = +($$[$0-2]) / +($$[$0]);
break;
case 26:
this.$ = +($$[$0-2]) % +($$[$0]);
break;
case 27:
this.$ = Math.pow($$[$0-2], $$[$0]);
break;
case 28:
this.$ = -1 * +($$[$0]);
break;
case 29:
this.$ = $$[$0-1];
break;
case 30:
this.$ = Number(yytext);
break;
case 31:

   this.$ = Date.parse(yytext.replace(/["']/g, ""));

break;
case 32:

   const qid = yytext.substring(1,yytext.length-1);
   this.$ = !yy.skippedQIDs.includes(qid) && yy.lookupQIDVal(qid);

break;
case 33:

   this.$ = yy.getCounterValue();

break;
case 34:
this.$ = yytext.substring(1,yytext.length-1); 
break;
case 35:
this.$ = Math.E;
break;
case 36:
this.$ = Math.PI;
break;
case 37:
this.$ = yy.getSubjectGender();
break;
case 38:
this.$ = yy.getSubjectAgeAtAsmt();
break;
case 39:
this.$ = yy.getSubjectTypeId();
break;
case 40:
this.$ = 'M';
break;
case 41:
this.$ = 'F';
break;
case 42:
 this.$ = null; 
break;
}
},
table: [{3:1,4:2,5:[1,3],6:$V0,7:$V1,10:$V2,11:$V3,12:$V4,13:$V5,14:$V6,15:$V7,16:$V8,17:$V9,27:$Va,32:$Vb,33:$Vc,34:$Vd,35:$Ve,36:$Vf,37:$Vg,38:$Vh,39:$Vi,40:$Vj,41:$Vk,42:$Vl,43:$Vm},{1:[3]},{5:[1,27],18:$Vn,19:$Vo,20:$Vp,21:$Vq,22:$Vr,23:$Vs,24:$Vt,25:$Vu,26:$Vv,27:$Vw,28:$Vx,29:$Vy,30:$Vz,31:$VA},{1:[2,2]},{7:[1,42]},{7:[1,43]},{7:[1,44]},{7:[1,45]},{7:[1,46]},{7:[1,47]},{7:[1,48]},{7:[1,49]},{4:50,6:$V0,7:$V1,10:$V2,11:$V3,12:$V4,13:$V5,14:$V6,15:$V7,16:$V8,17:$V9,27:$Va,32:$Vb,33:$Vc,34:$Vd,35:$Ve,36:$Vf,37:$Vg,38:$Vh,39:$Vi,40:$Vj,41:$Vk,42:$Vl,43:$Vm},{4:51,6:$V0,7:$V1,10:$V2,11:$V3,12:$V4,13:$V5,14:$V6,15:$V7,16:$V8,17:$V9,27:$Va,32:$Vb,33:$Vc,34:$Vd,35:$Ve,36:$Vf,37:$Vg,38:$Vh,39:$Vi,40:$Vj,41:$Vk,42:$Vl,43:$Vm},o($VB,[2,30]),o($VB,[2,31]),o($VB,[2,32]),o($VB,[2,33]),o($VB,[2,34]),o($VB,[2,35]),o($VB,[2,36]),o($VB,[2,37]),o($VB,[2,38]),o($VB,[2,39]),o($VB,[2,40]),o($VB,[2,41]),o($VB,[2,42]),{1:[2,1]},{4:52,6:$V0,7:$V1,10:$V2,11:$V3,12:$V4,13:$V5,14:$V6,15:$V7,16:$V8,17:$V9,27:$Va,32:$Vb,33:$Vc,34:$Vd,35:$Ve,36:$Vf,37:$Vg,38:$Vh,39:$Vi,40:$Vj,41:$Vk,42:$Vl,43:$Vm},{4:53,6:$V0,7:$V1,10:$V2,11:$V3,12:$V4,13:$V5,14:$V6,15:$V7,16:$V8,17:$V9,27:$Va,32:$Vb,33:$Vc,34:$Vd,35:$Ve,36:$Vf,37:$Vg,38:$Vh,39:$Vi,40:$Vj,41:$Vk,42:$Vl,43:$Vm},{4:54,6:$V0,7:$V1,10:$V2,11:$V3,12:$V4,13:$V5,14:$V6,15:$V7,16:$V8,17:$V9,27:$Va,32:$Vb,33:$Vc,34:$Vd,35:$Ve,36:$Vf,37:$Vg,38:$Vh,39:$Vi,40:$Vj,41:$Vk,42:$Vl,43:$Vm},{4:55,6:$V0,7:$V1,10:$V2,11:$V3,12:$V4,13:$V5,14:$V6,15:$V7,16:$V8,17:$V9,27:$Va,32:$Vb,33:$Vc,34:$Vd,35:$Ve,36:$Vf,37:$Vg,38:$Vh,39:$Vi,40:$Vj,41:$Vk,42:$Vl,43:$Vm},{4:56,6:$V0,7:$V1,10:$V2,11:$V3,12:$V4,13:$V5,14:$V6,15:$V7,16:$V8,17:$V9,27:$Va,32:$Vb,33:$Vc,34:$Vd,35:$Ve,36:$Vf,37:$Vg,38:$Vh,39:$Vi,40:$Vj,41:$Vk,42:$Vl,43:$Vm},{4:57,6:$V0,7:$V1,10:$V2,11:$V3,12:$V4,13:$V5,14:$V6,15:$V7,16:$V8,17:$V9,27:$Va,32:$Vb,33:$Vc,34:$Vd,35:$Ve,36:$Vf,37:$Vg,38:$Vh,39:$Vi,40:$Vj,41:$Vk,42:$Vl,43:$Vm},{4:58,6:$V0,7:$V1,10:$V2,11:$V3,12:$V4,13:$V5,14:$V6,15:$V7,16:$V8,17:$V9,27:$Va,32:$Vb,33:$Vc,34:$Vd,35:$Ve,36:$Vf,37:$Vg,38:$Vh,39:$Vi,40:$Vj,41:$Vk,42:$Vl,43:$Vm},{4:59,6:$V0,7:$V1,10:$V2,11:$V3,12:$V4,13:$V5,14:$V6,15:$V7,16:$V8,17:$V9,27:$Va,32:$Vb,33:$Vc,34:$Vd,35:$Ve,36:$Vf,37:$Vg,38:$Vh,39:$Vi,40:$Vj,41:$Vk,42:$Vl,43:$Vm},{4:60,6:$V0,7:$V1,10:$V2,11:$V3,12:$V4,13:$V5,14:$V6,15:$V7,16:$V8,17:$V9,27:$Va,32:$Vb,33:$Vc,34:$Vd,35:$Ve,36:$Vf,37:$Vg,38:$Vh,39:$Vi,40:$Vj,41:$Vk,42:$Vl,43:$Vm},{4:61,6:$V0,7:$V1,10:$V2,11:$V3,12:$V4,13:$V5,14:$V6,15:$V7,16:$V8,17:$V9,27:$Va,32:$Vb,33:$Vc,34:$Vd,35:$Ve,36:$Vf,37:$Vg,38:$Vh,39:$Vi,40:$Vj,41:$Vk,42:$Vl,43:$Vm},{4:62,6:$V0,7:$V1,10:$V2,11:$V3,12:$V4,13:$V5,14:$V6,15:$V7,16:$V8,17:$V9,27:$Va,32:$Vb,33:$Vc,34:$Vd,35:$Ve,36:$Vf,37:$Vg,38:$Vh,39:$Vi,40:$Vj,41:$Vk,42:$Vl,43:$Vm},{4:63,6:$V0,7:$V1,10:$V2,11:$V3,12:$V4,13:$V5,14:$V6,15:$V7,16:$V8,17:$V9,27:$Va,32:$Vb,33:$Vc,34:$Vd,35:$Ve,36:$Vf,37:$Vg,38:$Vh,39:$Vi,40:$Vj,41:$Vk,42:$Vl,43:$Vm},{4:64,6:$V0,7:$V1,10:$V2,11:$V3,12:$V4,13:$V5,14:$V6,15:$V7,16:$V8,17:$V9,27:$Va,32:$Vb,33:$Vc,34:$Vd,35:$Ve,36:$Vf,37:$Vg,38:$Vh,39:$Vi,40:$Vj,41:$Vk,42:$Vl,43:$Vm},{4:65,6:$V0,7:$V1,10:$V2,11:$V3,12:$V4,13:$V5,14:$V6,15:$V7,16:$V8,17:$V9,27:$Va,32:$Vb,33:$Vc,34:$Vd,35:$Ve,36:$Vf,37:$Vg,38:$Vh,39:$Vi,40:$Vj,41:$Vk,42:$Vl,43:$Vm},{4:66,6:$V0,7:$V1,10:$V2,11:$V3,12:$V4,13:$V5,14:$V6,15:$V7,16:$V8,17:$V9,27:$Va,32:$Vb,33:$Vc,34:$Vd,35:$Ve,36:$Vf,37:$Vg,38:$Vh,39:$Vi,40:$Vj,41:$Vk,42:$Vl,43:$Vm},{4:67,6:$V0,7:$V1,10:$V2,11:$V3,12:$V4,13:$V5,14:$V6,15:$V7,16:$V8,17:$V9,27:$Va,32:$Vb,33:$Vc,34:$Vd,35:$Ve,36:$Vf,37:$Vg,38:$Vh,39:$Vi,40:$Vj,41:$Vk,42:$Vl,43:$Vm},{4:68,6:$V0,7:$V1,10:$V2,11:$V3,12:$V4,13:$V5,14:$V6,15:$V7,16:$V8,17:$V9,27:$Va,32:$Vb,33:$Vc,34:$Vd,35:$Ve,36:$Vf,37:$Vg,38:$Vh,39:$Vi,40:$Vj,41:$Vk,42:$Vl,43:$Vm},{4:69,6:$V0,7:$V1,10:$V2,11:$V3,12:$V4,13:$V5,14:$V6,15:$V7,16:$V8,17:$V9,27:$Va,32:$Vb,33:$Vc,34:$Vd,35:$Ve,36:$Vf,37:$Vg,38:$Vh,39:$Vi,40:$Vj,41:$Vk,42:$Vl,43:$Vm},{4:70,6:$V0,7:$V1,10:$V2,11:$V3,12:$V4,13:$V5,14:$V6,15:$V7,16:$V8,17:$V9,27:$Va,32:$Vb,33:$Vc,34:$Vd,35:$Ve,36:$Vf,37:$Vg,38:$Vh,39:$Vi,40:$Vj,41:$Vk,42:$Vl,43:$Vm},{4:71,6:$V0,7:$V1,10:$V2,11:$V3,12:$V4,13:$V5,14:$V6,15:$V7,16:$V8,17:$V9,27:$Va,32:$Vb,33:$Vc,34:$Vd,35:$Ve,36:$Vf,37:$Vg,38:$Vh,39:$Vi,40:$Vj,41:$Vk,42:$Vl,43:$Vm},{16:[1,72]},{16:[1,73]},o($VB,[2,28]),{8:[1,74],18:$Vn,19:$Vo,20:$Vp,21:$Vq,22:$Vr,23:$Vs,24:$Vt,25:$Vu,26:$Vv,27:$Vw,28:$Vx,29:$Vy,30:$Vz,31:$VA},o([5,8,9,18],[2,14],{19:$Vo,20:$Vp,21:$Vq,22:$Vr,23:$Vs,24:$Vt,25:$Vu,26:$Vv,27:$Vw,28:$Vx,29:$Vy,30:$Vz,31:$VA}),o([5,8,9,18,19],[2,15],{20:$Vp,21:$Vq,22:$Vr,23:$Vs,24:$Vt,25:$Vu,26:$Vv,27:$Vw,28:$Vx,29:$Vy,30:$Vz,31:$VA}),o($VC,[2,16],{22:$Vr,23:$Vs,24:$Vt,25:$Vu,26:$Vv,27:$Vw,28:$Vx,29:$Vy,30:$Vz,31:$VA}),o($VC,[2,17],{22:$Vr,23:$Vs,24:$Vt,25:$Vu,26:$Vv,27:$Vw,28:$Vx,29:$Vy,30:$Vz,31:$VA}),o($VD,[2,18],{26:$Vv,27:$Vw,28:$Vx,29:$Vy,30:$Vz,31:$VA}),o($VD,[2,19],{26:$Vv,27:$Vw,28:$Vx,29:$Vy,30:$Vz,31:$VA}),o($VD,[2,20],{26:$Vv,27:$Vw,28:$Vx,29:$Vy,30:$Vz,31:$VA}),o($VD,[2,21],{26:$Vv,27:$Vw,28:$Vx,29:$Vy,30:$Vz,31:$VA}),o($VE,[2,22],{28:$Vx,29:$Vy,30:$Vz,31:$VA}),o($VE,[2,23],{28:$Vx,29:$Vy,30:$Vz,31:$VA}),o($VF,[2,24],{31:$VA}),o($VF,[2,25],{31:$VA}),o($VF,[2,26],{31:$VA}),o($VB,[2,27]),{8:[1,75],9:[1,76],18:$Vn,19:$Vo,20:$Vp,21:$Vq,22:$Vr,23:$Vs,24:$Vt,25:$Vu,26:$Vv,27:$Vw,28:$Vx,29:$Vy,30:$Vz,31:$VA},{8:[1,77],9:[1,78],18:$Vn,19:$Vo,20:$Vp,21:$Vq,22:$Vr,23:$Vs,24:$Vt,25:$Vu,26:$Vv,27:$Vw,28:$Vx,29:$Vy,30:$Vz,31:$VA},{8:[1,79],9:[1,80],18:$Vn,19:$Vo,20:$Vp,21:$Vq,22:$Vr,23:$Vs,24:$Vt,25:$Vu,26:$Vv,27:$Vw,28:$Vx,29:$Vy,30:$Vz,31:$VA},{8:[1,81],18:$Vn,19:$Vo,20:$Vp,21:$Vq,22:$Vr,23:$Vs,24:$Vt,25:$Vu,26:$Vv,27:$Vw,28:$Vx,29:$Vy,30:$Vz,31:$VA},{8:[1,82],18:$Vn,19:$Vo,20:$Vp,21:$Vq,22:$Vr,23:$Vs,24:$Vt,25:$Vu,26:$Vv,27:$Vw,28:$Vx,29:$Vy,30:$Vz,31:$VA},{9:[1,83],18:$Vn,19:$Vo,20:$Vp,21:$Vq,22:$Vr,23:$Vs,24:$Vt,25:$Vu,26:$Vv,27:$Vw,28:$Vx,29:$Vy,30:$Vz,31:$VA},{8:[1,84]},{8:[1,85]},o($VB,[2,29]),o($VB,[2,3]),{4:86,6:$V0,7:$V1,10:$V2,11:$V3,12:$V4,13:$V5,14:$V6,15:$V7,16:$V8,17:$V9,27:$Va,32:$Vb,33:$Vc,34:$Vd,35:$Ve,36:$Vf,37:$Vg,38:$Vh,39:$Vi,40:$Vj,41:$Vk,42:$Vl,43:$Vm},o($VB,[2,5]),{4:87,6:$V0,7:$V1,10:$V2,11:$V3,12:$V4,13:$V5,14:$V6,15:$V7,16:$V8,17:$V9,27:$Va,32:$Vb,33:$Vc,34:$Vd,35:$Ve,36:$Vf,37:$Vg,38:$Vh,39:$Vi,40:$Vj,41:$Vk,42:$Vl,43:$Vm},o($VB,[2,7]),{4:88,6:$V0,7:$V1,10:$V2,11:$V3,12:$V4,13:$V5,14:$V6,15:$V7,16:$V8,17:$V9,27:$Va,32:$Vb,33:$Vc,34:$Vd,35:$Ve,36:$Vf,37:$Vg,38:$Vh,39:$Vi,40:$Vj,41:$Vk,42:$Vl,43:$Vm},o($VB,[2,9]),o($VB,[2,10]),{4:89,6:$V0,7:$V1,10:$V2,11:$V3,12:$V4,13:$V5,14:$V6,15:$V7,16:$V8,17:$V9,27:$Va,32:$Vb,33:$Vc,34:$Vd,35:$Ve,36:$Vf,37:$Vg,38:$Vh,39:$Vi,40:$Vj,41:$Vk,42:$Vl,43:$Vm},o($VB,[2,12]),o($VB,[2,13]),{8:[1,90],18:$Vn,19:$Vo,20:$Vp,21:$Vq,22:$Vr,23:$Vs,24:$Vt,25:$Vu,26:$Vv,27:$Vw,28:$Vx,29:$Vy,30:$Vz,31:$VA},{8:[1,91],18:$Vn,19:$Vo,20:$Vp,21:$Vq,22:$Vr,23:$Vs,24:$Vt,25:$Vu,26:$Vv,27:$Vw,28:$Vx,29:$Vy,30:$Vz,31:$VA},{8:[1,92],18:$Vn,19:$Vo,20:$Vp,21:$Vq,22:$Vr,23:$Vs,24:$Vt,25:$Vu,26:$Vv,27:$Vw,28:$Vx,29:$Vy,30:$Vz,31:$VA},{9:[1,93],18:$Vn,19:$Vo,20:$Vp,21:$Vq,22:$Vr,23:$Vs,24:$Vt,25:$Vu,26:$Vv,27:$Vw,28:$Vx,29:$Vy,30:$Vz,31:$VA},o($VB,[2,4]),o($VB,[2,6]),o($VB,[2,8]),{4:94,6:$V0,7:$V1,10:$V2,11:$V3,12:$V4,13:$V5,14:$V6,15:$V7,16:$V8,17:$V9,27:$Va,32:$Vb,33:$Vc,34:$Vd,35:$Ve,36:$Vf,37:$Vg,38:$Vh,39:$Vi,40:$Vj,41:$Vk,42:$Vl,43:$Vm},{8:[1,95],18:$Vn,19:$Vo,20:$Vp,21:$Vq,22:$Vr,23:$Vs,24:$Vt,25:$Vu,26:$Vv,27:$Vw,28:$Vx,29:$Vy,30:$Vz,31:$VA},o($VB,[2,11])],
defaultActions: {3:[2,2],27:[2,1]},
parseError: function parseError (str, hash) {
    if (hash.recoverable) {
        this.trace(str);
    } else {
        var error = new Error(str);
        error.hash = hash;
        throw error;
    }
},
parse: function parse(input) {
    var self = this, stack = [0], tstack = [], vstack = [null], lstack = [], table = this.table, yytext = '', yylineno = 0, yyleng = 0, recovering = 0, TERROR = 2, EOF = 1;
    var args = lstack.slice.call(arguments, 1);
    var lexer = Object.create(this.lexer);
    var sharedState = { yy: {} };
    for (var k in this.yy) {
        if (Object.prototype.hasOwnProperty.call(this.yy, k)) {
            sharedState.yy[k] = this.yy[k];
        }
    }
    lexer.setInput(input, sharedState.yy);
    sharedState.yy.lexer = lexer;
    sharedState.yy.parser = this;
    if (typeof lexer.yylloc == 'undefined') {
        lexer.yylloc = {};
    }
    var yyloc = lexer.yylloc;
    lstack.push(yyloc);
    var ranges = lexer.options && lexer.options.ranges;
    if (typeof sharedState.yy.parseError === 'function') {
        this.parseError = sharedState.yy.parseError;
    } else {
        this.parseError = Object.getPrototypeOf(this).parseError;
    }
    function popStack(n) {
        stack.length = stack.length - 2 * n;
        vstack.length = vstack.length - n;
        lstack.length = lstack.length - n;
    }
    _token_stack:
        var lex = function () {
            var token;
            token = lexer.lex() || EOF;
            if (typeof token !== 'number') {
                token = self.symbols_[token] || token;
            }
            return token;
        };
    var symbol, preErrorSymbol, state, action, a, r, yyval = {}, p, len, newState, expected;
    while (true) {
        state = stack[stack.length - 1];
        if (this.defaultActions[state]) {
            action = this.defaultActions[state];
        } else {
            if (symbol === null || typeof symbol == 'undefined') {
                symbol = lex();
            }
            action = table[state] && table[state][symbol];
        }
                    if (typeof action === 'undefined' || !action.length || !action[0]) {
                var errStr = '';
                expected = [];
                for (p in table[state]) {
                    if (this.terminals_[p] && p > TERROR) {
                        expected.push('\'' + this.terminals_[p] + '\'');
                    }
                }
                if (lexer.showPosition) {
                    errStr = 'Parse error on line ' + (yylineno + 1) + ':\n' + lexer.showPosition() + '\nExpecting ' + expected.join(', ') + ', got \'' + (this.terminals_[symbol] || symbol) + '\'';
                } else {
                    errStr = 'Parse error on line ' + (yylineno + 1) + ': Unexpected ' + (symbol == EOF ? 'end of input' : '\'' + (this.terminals_[symbol] || symbol) + '\'');
                }
                this.parseError(errStr, {
                    text: lexer.match,
                    token: this.terminals_[symbol] || symbol,
                    line: lexer.yylineno,
                    loc: yyloc,
                    expected: expected
                });
            }
        if (action[0] instanceof Array && action.length > 1) {
            throw new Error('Parse Error: multiple actions possible at state: ' + state + ', token: ' + symbol);
        }
        switch (action[0]) {
        case 1:
            stack.push(symbol);
            vstack.push(lexer.yytext);
            lstack.push(lexer.yylloc);
            stack.push(action[1]);
            symbol = null;
            if (!preErrorSymbol) {
                yyleng = lexer.yyleng;
                yytext = lexer.yytext;
                yylineno = lexer.yylineno;
                yyloc = lexer.yylloc;
                if (recovering > 0) {
                    recovering--;
                }
            } else {
                symbol = preErrorSymbol;
                preErrorSymbol = null;
            }
            break;
        case 2:
            len = this.productions_[action[1]][1];
            yyval.$ = vstack[vstack.length - len];
            yyval._$ = {
                first_line: lstack[lstack.length - (len || 1)].first_line,
                last_line: lstack[lstack.length - 1].last_line,
                first_column: lstack[lstack.length - (len || 1)].first_column,
                last_column: lstack[lstack.length - 1].last_column
            };
            if (ranges) {
                yyval._$.range = [
                    lstack[lstack.length - (len || 1)].range[0],
                    lstack[lstack.length - 1].range[1]
                ];
            }
            r = this.performAction.apply(yyval, [
                yytext,
                yyleng,
                yylineno,
                sharedState.yy,
                action[1],
                vstack,
                lstack
            ].concat(args));
            if (typeof r !== 'undefined') {
                return r;
            }
            if (len) {
                stack = stack.slice(0, -1 * len * 2);
                vstack = vstack.slice(0, -1 * len);
                lstack = lstack.slice(0, -1 * len);
            }
            stack.push(this.productions_[action[1]][0]);
            vstack.push(yyval.$);
            lstack.push(yyval._$);
            newState = table[stack[stack.length - 2]][stack[stack.length - 1]];
            stack.push(newState);
            break;
        case 3:
            return true;
        }
    }
    return true;
}};
/* generated by jison-lex 0.3.4 */
var lexer = (function(){
var lexer = ({

EOF:1,

parseError:function parseError(str, hash) {
        if (this.yy.parser) {
            this.yy.parser.parseError(str, hash);
        } else {
            throw new Error(str);
        }
    },

// resets the lexer, sets new input
setInput:function (input, yy) {
        this.yy = yy || this.yy || {};
        this._input = input;
        this._more = this._backtrack = this.done = false;
        this.yylineno = this.yyleng = 0;
        this.yytext = this.matched = this.match = '';
        this.conditionStack = ['INITIAL'];
        this.yylloc = {
            first_line: 1,
            first_column: 0,
            last_line: 1,
            last_column: 0
        };
        if (this.options.ranges) {
            this.yylloc.range = [0,0];
        }
        this.offset = 0;
        return this;
    },

// consumes and returns one char from the input
input:function () {
        var ch = this._input[0];
        this.yytext += ch;
        this.yyleng++;
        this.offset++;
        this.match += ch;
        this.matched += ch;
        var lines = ch.match(/(?:\r\n?|\n).*/g);
        if (lines) {
            this.yylineno++;
            this.yylloc.last_line++;
        } else {
            this.yylloc.last_column++;
        }
        if (this.options.ranges) {
            this.yylloc.range[1]++;
        }

        this._input = this._input.slice(1);
        return ch;
    },

// unshifts one char (or a string) into the input
unput:function (ch) {
        var len = ch.length;
        var lines = ch.split(/(?:\r\n?|\n)/g);

        this._input = ch + this._input;
        this.yytext = this.yytext.substr(0, this.yytext.length - len);
        //this.yyleng -= len;
        this.offset -= len;
        var oldLines = this.match.split(/(?:\r\n?|\n)/g);
        this.match = this.match.substr(0, this.match.length - 1);
        this.matched = this.matched.substr(0, this.matched.length - 1);

        if (lines.length - 1) {
            this.yylineno -= lines.length - 1;
        }
        var r = this.yylloc.range;

        this.yylloc = {
            first_line: this.yylloc.first_line,
            last_line: this.yylineno + 1,
            first_column: this.yylloc.first_column,
            last_column: lines ?
                (lines.length === oldLines.length ? this.yylloc.first_column : 0)
                 + oldLines[oldLines.length - lines.length].length - lines[0].length :
              this.yylloc.first_column - len
        };

        if (this.options.ranges) {
            this.yylloc.range = [r[0], r[0] + this.yyleng - len];
        }
        this.yyleng = this.yytext.length;
        return this;
    },

// When called from action, caches matched text and appends it on next action
more:function () {
        this._more = true;
        return this;
    },

// When called from action, signals the lexer that this rule fails to match the input, so the next matching rule (regex) should be tested instead.
reject:function () {
        if (this.options.backtrack_lexer) {
            this._backtrack = true;
        } else {
            return this.parseError('Lexical error on line ' + (this.yylineno + 1) + '. You can only invoke reject() in the lexer when the lexer is of the backtracking persuasion (options.backtrack_lexer = true).\n' + this.showPosition(), {
                text: "",
                token: null,
                line: this.yylineno
            });

        }
        return this;
    },

// retain first n characters of the match
less:function (n) {
        this.unput(this.match.slice(n));
    },

// displays already matched input, i.e. for error messages
pastInput:function () {
        var past = this.matched.substr(0, this.matched.length - this.match.length);
        return (past.length > 20 ? '...':'') + past.substr(-20).replace(/\n/g, "");
    },

// displays upcoming input, i.e. for error messages
upcomingInput:function () {
        var next = this.match;
        if (next.length < 20) {
            next += this._input.substr(0, 20-next.length);
        }
        return (next.substr(0,20) + (next.length > 20 ? '...' : '')).replace(/\n/g, "");
    },

// displays the character position where the lexing error occurred, i.e. for error messages
showPosition:function () {
        var pre = this.pastInput();
        var c = new Array(pre.length + 1).join("-");
        return pre + this.upcomingInput() + "\n" + c + "^";
    },

// test the lexed token: return FALSE when not a match, otherwise return token
test_match:function(match, indexed_rule) {
        var token,
            lines,
            backup;

        if (this.options.backtrack_lexer) {
            // save context
            backup = {
                yylineno: this.yylineno,
                yylloc: {
                    first_line: this.yylloc.first_line,
                    last_line: this.last_line,
                    first_column: this.yylloc.first_column,
                    last_column: this.yylloc.last_column
                },
                yytext: this.yytext,
                match: this.match,
                matches: this.matches,
                matched: this.matched,
                yyleng: this.yyleng,
                offset: this.offset,
                _more: this._more,
                _input: this._input,
                yy: this.yy,
                conditionStack: this.conditionStack.slice(0),
                done: this.done
            };
            if (this.options.ranges) {
                backup.yylloc.range = this.yylloc.range.slice(0);
            }
        }

        lines = match[0].match(/(?:\r\n?|\n).*/g);
        if (lines) {
            this.yylineno += lines.length;
        }
        this.yylloc = {
            first_line: this.yylloc.last_line,
            last_line: this.yylineno + 1,
            first_column: this.yylloc.last_column,
            last_column: lines ?
                         lines[lines.length - 1].length - lines[lines.length - 1].match(/\r?\n?/)[0].length :
                         this.yylloc.last_column + match[0].length
        };
        this.yytext += match[0];
        this.match += match[0];
        this.matches = match;
        this.yyleng = this.yytext.length;
        if (this.options.ranges) {
            this.yylloc.range = [this.offset, this.offset += this.yyleng];
        }
        this._more = false;
        this._backtrack = false;
        this._input = this._input.slice(match[0].length);
        this.matched += match[0];
        token = this.performAction.call(this, this.yy, this, indexed_rule, this.conditionStack[this.conditionStack.length - 1]);
        if (this.done && this._input) {
            this.done = false;
        }
        if (token) {
            return token;
        } else if (this._backtrack) {
            // recover context
            for (var k in backup) {
                this[k] = backup[k];
            }
            return false; // rule action called reject() implying the next rule should be tested instead.
        }
        return false;
    },

// return next match in input
next:function () {
        if (this.done) {
            return this.EOF;
        }
        if (!this._input) {
            this.done = true;
        }

        var token,
            match,
            tempMatch,
            index;
        if (!this._more) {
            this.yytext = '';
            this.match = '';
        }
        var rules = this._currentRules();
        for (var i = 0; i < rules.length; i++) {
            tempMatch = this._input.match(this.rules[rules[i]]);
            if (tempMatch && (!match || tempMatch[0].length > match[0].length)) {
                match = tempMatch;
                index = i;
                if (this.options.backtrack_lexer) {
                    token = this.test_match(tempMatch, rules[i]);
                    if (token !== false) {
                        return token;
                    } else if (this._backtrack) {
                        match = false;
                        continue; // rule action called reject() implying a rule MISmatch.
                    } else {
                        // else: this is a lexer rule which consumes input without producing a token (e.g. whitespace)
                        return false;
                    }
                } else if (!this.options.flex) {
                    break;
                }
            }
        }
        if (match) {
            token = this.test_match(match, rules[index]);
            if (token !== false) {
                return token;
            }
            // else: this is a lexer rule which consumes input without producing a token (e.g. whitespace)
            return false;
        }
        if (this._input === "") {
            return this.EOF;
        } else {
            return this.parseError('Lexical error on line ' + (this.yylineno + 1) + '. Unrecognized text.\n' + this.showPosition(), {
                text: "",
                token: null,
                line: this.yylineno
            });
        }
    },

// return next match that has a token
lex:function lex () {
        var r = this.next();
        if (r) {
            return r;
        } else {
            return this.lex();
        }
    },

// activates a new lexer condition state (pushes the new lexer condition state onto the condition stack)
begin:function begin (condition) {
        this.conditionStack.push(condition);
    },

// pop the previously active lexer condition state off the condition stack
popState:function popState () {
        var n = this.conditionStack.length - 1;
        if (n > 0) {
            return this.conditionStack.pop();
        } else {
            return this.conditionStack[0];
        }
    },

// produce the lexer rule set which is active for the currently active lexer condition state
_currentRules:function _currentRules () {
        if (this.conditionStack.length && this.conditionStack[this.conditionStack.length - 1]) {
            return this.conditions[this.conditionStack[this.conditionStack.length - 1]].rules;
        } else {
            return this.conditions["INITIAL"].rules;
        }
    },

// return the currently active lexer condition state; when an index argument is provided it produces the N-th previous condition state, if available
topState:function topState (n) {
        n = this.conditionStack.length - 1 - Math.abs(n || 0);
        if (n >= 0) {
            return this.conditionStack[n];
        } else {
            return "INITIAL";
        }
    },

// alias for begin(condition)
pushState:function pushState (condition) {
        this.begin(condition);
    },

// return the number of states currently on the stack
stateStackSize:function stateStackSize() {
        return this.conditionStack.length;
    },
options: {"case-insensitive":true},
performAction: function anonymous(yy,yy_,$avoiding_name_collisions,YY_START) {
var YYSTATE=YY_START;
switch($avoiding_name_collisions) {
case 0:/* skip whitespace */
break;
case 1:return ","
break;
case 2:return 32
break;
case 3:return 32
break;
case 4:return 33
break;
case 5:return 33
break;
case 6:return 16
break;
case 7:return 35
break;
case 8:return 35
break;
case 9:return 34
break;
case 10:return 28
break;
case 11:return 29
break;
case 12:return 30
break;
case 13:return 27
break;
case 14:return 26
break;
case 15:return 31
break;
case 16:return 7
break;
case 17:return 8
break;
case 18:return '['
break;
case 19:return ']'
break;
case 20:return 37
break;
case 21:return 36
break;
case 22:return 6
break;
case 23:return 6
break;
case 24:return 10
break;
case 25:return 10
break;
case 26:return 11
break;
case 27:return 11
break;
case 28:return 12
break;
case 29:return 12
break;
case 30:return 14
break;
case 31:return 15
break;
case 32:return 17
break;
case 33:return 13
break;
case 34:return 20
break;
case 35:return 20
break;
case 36:return 21
break;
case 37:return 24
break;
case 38:return 22
break;
case 39:return 25
break;
case 40:return 23
break;
case 41:return 19
break;
case 42:return 19
break;
case 43:return 19
break;
case 44:return 18
break;
case 45:return 18
break;
case 46:return 18
break;
case 47:return 43
break;
case 48:return 5
break;
case 49:return 41
break;
case 50:return 42
break;
case 51:return 38
break;
case 52:return 39
break;
case 53:return 40
break;
case 54:return 'INVALID'
break;
}
},
rules: [/^(?:\s+)/i,/^(?:,)/i,/^(?:[0-9]*\.[0-9]+\b)/i,/^(?:[0-9]+)/i,/^(?:"[0-9]{2}\/[0-9]{2}\/[0-9]{4}")/i,/^(?:'[0-9]{2}\/[0-9]{2}\/[0-9]{4}')/i,/^(?:\[.*?\])/i,/^(?:'.*?')/i,/^(?:".*?")/i,/^(?:COUNTER\b)/i,/^(?:\*)/i,/^(?:\/)/i,/^(?:%)/i,/^(?:-)/i,/^(?:\+)/i,/^(?:\^)/i,/^(?:\()/i,/^(?:\))/i,/^(?:\[)/i,/^(?:\])/i,/^(?:PI\b)/i,/^(?:E\b)/i,/^(?:floor_f\b)/i,/^(?:floor\b)/i,/^(?:ceil_f\b)/i,/^(?:ceil\b)/i,/^(?:round_f\b)/i,/^(?:round\b)/i,/^(?:abs_f\b)/i,/^(?:abs\b)/i,/^(?:iif\b)/i,/^(?:sum_over_all_instances\b)/i,/^(?:revscore\b)/i,/^(?:to_utc\b)/i,/^(?:==)/i,/^(?:=)/i,/^(?:!=)/i,/^(?:<=)/i,/^(?:>=)/i,/^(?:<)/i,/^(?:>)/i,/^(?:and\b)/i,/^(?:&&)/i,/^(?:&)/i,/^(?:or\b)/i,/^(?:\|\|)/i,/^(?:\|)/i,/^(?:null\b)/i,/^(?:$)/i,/^(?:M\b)/i,/^(?:F\b)/i,/^(?:GENDER\b)/i,/^(?:AGE\b)/i,/^(?:SUBJECTTYPEID\b)/i,/^(?:.)/i],
conditions: {"INITIAL":{"rules":[0,1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30,31,32,33,34,35,36,37,38,39,40,41,42,43,44,45,46,47,48,49,50,51,52,53,54],"inclusive":true}}
});
return lexer;
})();
parser.lexer = lexer;
function Parser () {
  this.yy = {};
}
Parser.prototype = parser;parser.Parser = Parser;
return new Parser;
})();


if (typeof require !== 'undefined' && typeof exports !== 'undefined') {
exports.parser = parser;
exports.Parser = parser.Parser;
exports.parse = function () { return parser.parse.apply(parser, arguments); };
exports.main = function commonjsMain (args) {
    if (!args[1]) {
        console.log('Usage: '+args[0]+' FILE');
        process.exit(1);
    }
    var source = require('fs').readFileSync(require('path').normalize(args[1]), "utf8");
    return exports.parser.parse(source);
};
if (typeof module !== 'undefined' && require.main === module) {
  exports.main(process.argv.slice(1));
}
}